@if (label()) {
  <label [for]="inputId"
    >{{ label() }}
    @if (isRequired) {
      *
    }
  </label>
}
<mat-form-field appearance="outline" subscriptSizing="dynamic" [class.error-state]="showErrors">
  @if (icon()) {
    <fa-icon matPrefix [icon]="icon()" size="sm"></fa-icon>
  } @else if (prefixText()) {
    <div matPrefix class="prefix-text">{{ prefixText() }}</div>
  }
  <!-- AUTOCOMPLETE -->
  @if (isAutocomplete) {
    <input
      type="text"
      matInput
      [matAutocomplete]="auto"
      [id]="inputId"
      [placeholder]="placeholder()"
      [formControl]="autoControl"
      [required]="isRequired"
    />

    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayOption">
      @for (option of options(); track $index) {
        <mat-option [value]="option">
          {{ option.label }}
        </mat-option>
      }
    </mat-autocomplete>

    @if (loading()) {
      <mat-spinner matSuffix diameter="18"></mat-spinner>
    }
  } @else if (isSelect) {
    <!-- SELECT -->
    <mat-select
      [placeholder]="placeholder()"
      [id]="inputId"
      [value]="value"
      [disabled]="disabled"
      [required]="isRequired"
      (blur)="handleBlur()"
      (selectionChange)="updateValue($event.value)"
    >
      @for (option of options(); track $index) {
        <mat-option [value]="option.value">
          {{ option.label }}
        </mat-option>
      }
    </mat-select>
  } @else if (isChipsAutocomplete) {
    <!-- CHIPS -->
    <mat-chip-grid #chipGrid [value]="value" [disabled]="disabled">
      @for (option of value; track $index) {
        <mat-chip-row (removed)="remove(option)">
          {{ option }}
          <button matChipRemove [attr.aria-label]="'remove ' + option.label">
            <fa-icon [icon]="['fas', 'xmark']" size="2xs" [style.height]="'17px'"></fa-icon>
          </button>
        </mat-chip-row>
      }
    </mat-chip-grid>
    <input
      [id]="inputId"
      [placeholder]="placeholder()"
      #chipInput
      [(ngModel)]="searchText"
      [matChipInputFor]="chipGrid"
      [matAutocomplete]="autoChip"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="add($event)"
    />
    <mat-autocomplete
      #autoChip="matAutocomplete"
      (optionSelected)="selected($event); chipInput.value = ''"
    >
      @for (option of filteredOptions(); track $index) {
        <mat-option [value]="option.value">{{ option.label }}</mat-option>
      }
    </mat-autocomplete>
  } @else if (isTextarea) {
    <!-- TEXT AREA -->
    <textarea
      matInput
      [id]="inputId"
      [placeholder]="placeholder()"
      [value]="value"
      [disabled]="disabled"
      [required]="isRequired"
      (input)="updateValue($any($event.target).value)"
      (blur)="handleBlur()"
      rows="4"
    ></textarea>
  } @else {
    <!-- INPUT -->
    <input
      matInput
      [type]="hide() ? type() : 'text'"
      [autocomplete]="autocomplete()"
      [id]="inputId"
      [placeholder]="placeholder()"
      [value]="value"
      [disabled]="disabled"
      [required]="isRequired"
      (input)="updateValue($any($event.target).value)"
      (blur)="handleBlur()"
    />
  }

  @if (suffixText()) {
    <div matSuffix class="suffix-text">{{ suffixText() }}</div>
  } @else if (type() === 'password') {
    <button
      type="button"
      matRipple
      matSuffix
      (click)="passwordTrigger($event)"
      [attr.aria-label]="'Hide password'"
      [attr.aria-pressed]="hide()"
    >
      <fa-icon id="password-eye" [icon]="hide() ? 'eye' : 'eye-slash'" size="lg"></fa-icon>
    </button>
  }
</mat-form-field>

@if (showErrors || showAutoErrors) {
  <div class="error">
    <span>{{ errorMessage }}</span>
  </div>
} @else if (hint()) {
  <div class="hint">{{ hint() }}</div>
}
